export const SWIPE_THRESHOLD = 0.2;
export const CLOSE_THRESHOLD = 80;
export const DECIDE_THRESHOLD = 8;
export const RESISTANCE = 0.6;
export const EDGE_RESISTANCE = 0.15;
export const SNAP_DURATION = 300;
export const SWIPE_DURATION = 320;
export const ZOOM_DURATION = 300;
export const MIN_SCALE = 1;
export const DOUBLE_TAP_ZOOM = 2;
export const DOUBLE_TAP_DELAY = 300;
